// This section ties to ScheduleType on the backend
const INSURED_LOCATIONS = 'INSURED_LOCATIONS'
// const ADDITIONAL_LOCATIONS = 'ADDITIONAL_LOCATIONS'
const LOCATIONS = 'LOCATIONS'
const PROPERTY_COVERAGES = 'PROPERTY_COVERAGES'
const EDP = 'EDP'
const AUTO = 'AUTO'
const DRIVERS = 'DRIVERS'
const EQUIPMENT = 'EQUIPMENT'
const UNSCHEDULED_EQUIPMENT = 'UNSCHEDULED_EQUIPMENT'
const INLAND_MARINE = 'INLAND_MARINE'
const GENERAL_LIABILITY = 'GENERAL_LIABILITY'
const WORKERS_COMP = 'WORKERS_COMP'
const EXEC_WORKERS_COMP = 'EXEC_WORKERS_COMP'
const PIP = 'PIP'
const VESSEL = 'VESSEL'
const DRIVE_OTHER = 'DRIVE_OTHER'
const MISC_PROP_FLOATER = 'MISC_PROP_FLOATER'
const ADDL_INTERESTS = 'ADDL_INTERESTS'
const NAMED_INSUREDS = 'NAMED_INSUREDS'
const TRANSPORT = 'TRANSPORT'
const UMBRELLA = 'UMBRELLA'
const EXCESS_LIABILITY = 'EXCESS_LIABILITY'
const MISCELLANEOUS = 'MISCELLANEOUS'
const CRIME = 'CRIME'
const CYBER = 'CYBER'
const FINE_ARTS = 'FINE_ARTS'
const GARAGE = 'GARAGE'
const GARAGE_KEEPER = 'GARAGE_KEEPER'
const OWNER_OPS = 'OWNER_OPS'
const STORAGE_TANKS = 'STORAGE_TANKS'
const TRAILER_INTERCHANGE = 'TRAILER_INTERCHANGE'
const WORK_COMP_PLUS_GL = 'WORK_COMP_PLUS_GL'
const BUSINESS_INCOME_WORKSHEET = 'BUSINESS_INCOME_WORKSHEET'
// NON SCHEDULE TYPES
const CERTIFICATE_OF_INSURANCE = 'CERTIFICATE_OF_INSURANCE'
/**
 * These types are used in several contexts - Hopefully we can use these
 * for all of our schedule needs - still need to convert a few items
 * - Preferences
 * - Schedule Limits
 * - SchedulesMain
 * - Etc
 */
export function getScheduleTypeFromFrontend(frontend) {
  if (frontend == null) {
    return null
  }
  const values = Object.values(SCHEDULE_TYPES)
  const found = values.find(v => v.frontend === frontend)
  return found
}
const SCHEDULE_TYPES = {
  LOCATIONS: {
    backend: LOCATIONS,
  },
  NAMED_INSUREDS: {
    backend: NAMED_INSUREDS,
    display: 'Named Insureds',
    frontend: 'named-insured',
    component: 'named-insured-schedule',
    props: {
      'route-name': 'named-insured',
    },
  },
  INSURED_LOCATIONS: {
    backend: INSURED_LOCATIONS,
    display: 'Insured Locations',
    frontend: 'insured-locations',
    component: 'insured-locations-schedule',
    props: {
      'route-name': 'insured-locations',
    },
  },
  PROPERTY: {
    backend: PROPERTY_COVERAGES,
    display: 'Property',
    frontend: 'property',
    component: 'property-schedule',
    props: {
      'route-name': 'property',
    },
    ams: {
      type: LOCATIONS,
      filenamePart: 'property-both',
    },
  },
  AUTO: {
    backend: AUTO,
    display: 'Auto',
    frontend: 'auto',
    component: 'auto-schedule',
    props: {
      'route-name': 'auto',
    },
    ams: {
      type: AUTO,
      filenamePart: 'auto',
    },
  },
  DRIVERS: {
    backend: DRIVERS,
    display: 'Drivers',
    frontend: 'driver',
    component: 'driver-schedule',
    props: {
      'route-name': 'driver',
    },
    ams: {
      type: DRIVERS,
      filenamePart: 'drivers',
    },
  },
  EQUIPMENT: {
    backend: EQUIPMENT,
    display: 'Equipment',
    frontend: 'equipment',
    component: 'contractors-equipment-schedule',
    props: {
      'route-name': 'equipment',
    },
    ams: {
      type: EQUIPMENT,
      filenamePart: 'equipment',
    },
  },
  EDP: {
    backend: EDP,
    display: 'EDP',
    frontend: 'edp',
    component: 'edp-schedule',
    props: {
      'route-name': 'edp',
    },
  },
  UNSCHEDULED_EQUIPMENT: {
    backend: UNSCHEDULED_EQUIPMENT,
    display: 'Unscheduled Equipment',
    frontend: 'unscheduled-equipment',
    component: 'unscheduled-equipment',
    props: {
      'route-name': 'unscheduled-equipment',
    },
  },
  INLAND_MARINE: {
    backend: INLAND_MARINE,
    display: 'Inland Marine',
    frontend: 'inland-marine',
    component: 'inland-marine',
    props: {
      'route-name': 'inland-marine',
    },
  },
  GENERAL_LIABILITY: {
    backend: GENERAL_LIABILITY,
    display: 'General Liability',
    frontend: 'general-liability',
    component: 'general-liability-schedule',
    props: {
      'route-name': 'general-liability',
    },
    ams: {
      type: GENERAL_LIABILITY,
      filenamePart: 'general-liability',
    },
  },
  WORKERS_COMP: {
    backend: WORKERS_COMP,
    display: 'Work Comp',
    frontend: 'work-comp',
    component: 'workers-comp-schedule',
    props: {
      'route-name': 'work-comp',
    },
    ams: {
      type: WORKERS_COMP,
      filenamePart: 'work-comp',
    },
  },
  EXEC_WORKERS_COMP: {
    backend: EXEC_WORKERS_COMP,
    display: 'Exec Work Comp',
    frontend: 'executive-comp',
    component: 'executive-officer-schedule',
    props: {
      'route-name': 'executive-comp',
    },
  },
  PIP: {
    backend: PIP,
    display: 'Personal Injury',
    frontend: 'pip',
    component: 'pip-schedule',
    props: {
      'route-name': 'pip',
    },
  },
  VESSEL: {
    backend: VESSEL,
    display: 'Ocean Cargo',
    frontend: 'vessel',
    component: 'vessel-schedule',
    props: {
      'route-name': 'vessel',
    },
  },
  MISC_PROP_FLOATER: {
    backend: MISC_PROP_FLOATER,
    display: 'Misc Property Floater',
    frontend: 'misc-prop-floater',
    component: 'misc-prop-floater-schedule',
    props: {
      'route-name': 'misc-prop-floater',
    },
  },
  DRIVE_OTHER: {
    backend: DRIVE_OTHER,
    display: 'Drive Other Car',
    frontend: 'drive-other',
    component: 'drive-other-schedule',
    props: {
      'route-name': 'drive-other',
    },
  },
  ADDL_INTERESTS: {
    backend: ADDL_INTERESTS,
    display: 'Additional Interests',
    frontend: 'addl-interests',
    component: 'addl-interests-schedule',
    props: {
      'route-name': 'addl-interests',
    },
  },
  TRANSPORT: {
    backend: TRANSPORT,
    display: 'Transportation',
    frontend: 'transport',
    component: 'transport-schedule',
    props: {
      'route-name': 'transport',
    },
  },
  UMBRELLA: {
    backend: UMBRELLA,
  },
  EXCESS_LIABILITY: {
    backend: EXCESS_LIABILITY,
  },
  CRIME: {
    backend: CRIME,
  },
  CYBER: {
    backend: CYBER,
  },
  MISCELLANEOUS: {
    backend: MISCELLANEOUS,
    display: 'Misc. Coverages',
    frontend: 'miscellaneous',
    component: 'miscellaneous-schedule',
    props: {
      'route-name': 'miscellaneous',
    },
    wizardImportable: false,
  },
  FINE_ARTS: {
    backend: FINE_ARTS,
    display: 'Fine Arts',
    frontend: 'fine-arts',
    component: 'fine-arts-schedule',
    props: {
      'route-name': 'fine-arts',
    },
  },
  GARAGE: {
    backend: GARAGE,
    display: 'Garage',
    frontend: 'garage',
    component: 'garage-schedule',
    props: {
      'route-name': 'garage',
    },
  },
  GARAGE_KEEPER: {
    backend: GARAGE_KEEPER,
    display: 'Garage Keeper',
    frontend: 'garage-keeper',
    component: 'garage-keeper-schedule',
    props: {
      'route-name': 'garage-keeper',
    },
  },
  OWNER_OPS: {
    backend: OWNER_OPS,
    display: 'Owner Ops',
    frontend: 'owner-ops',
    component: 'owner-ops-schedule',
    props: {
      'route-name': 'owner-ops',
    },
  },
  STORAGE_TANKS: {
    backend: STORAGE_TANKS,
    display: 'Storage Tanks',
    frontend: 'storage-tanks',
    component: 'storage-tanks-schedule',
    props: {
      'route-name': 'storage-tanks',
    },
  },
  TRAILER_INTERCHANGE: {
    backend: TRAILER_INTERCHANGE,
    display: 'Trailer Interchange',
    frontend: 'trailer-interchange',
    component: 'trailer-interchange-schedule',
    props: {
      'route-name': 'trailer-interchange',
    },
  },
  WORK_COMP_PLUS_GL: {
    backend: WORK_COMP_PLUS_GL,
    display: 'WC/GL Payroll',
    frontend: 'work-comp-plus-gl',
    component: 'work-comp-plus-gl-schedule',
    props: {
      'route-name': 'work-comp-plus-gl',
    },
  },
  OPEN_LOT: {
    backend: 'OPEN_LOT',
    display: 'Open Lot',
    frontend: 'open-lot',
    component: 'open-lot-schedule',
    props: {
      'route-name': 'open-lot',
    },
  },
  BUSINESS_INCOME_WORKSHEET: {
    backend: BUSINESS_INCOME_WORKSHEET,
    display: 'Business Income Worksheet',
    frontend: 'business-income-worksheet',
    component: 'business-income-worksheet',
    props: {
      'route-name': 'business-income-worksheet',
    },
    wizardImportable: false,
  },
  // NON SCHEDULE TYPES
  CERTIFICATE_OF_INSURANCE: {
    backend: CERTIFICATE_OF_INSURANCE,
    display: 'Certificates Of Insurance',
    frontend: 'certificates',
    component: 'certificates',
    props: {
      'route-name': 'certificate-insurance',
    },
    hideFromSchedulePage: true,
  },
  INTERNATIONAL_TRAVEL: {
    backend: 'INTERNATIONAL_TRAVEL',
    display: 'International Travel',
    frontend: 'international-travel',
    component: 'international-travel-schedule',
    props: {
      'route-name': 'international-travel',
    },
  },
}

export default SCHEDULE_TYPES
